import { isNil } from 'lodash';
import { MagicLinkHelper } from '~domain/helper/url/magic-link/magic-link-helper';
import { LanguageId } from '~domain/model/core/supported-languages';
import { FrontendCommonConfig } from '~frontend-common/config';
import { applicationClient } from '~web-portal/clients/application-client';
import { getUserAuth } from '~web-portal/helpers/get-user-auth';
import { policyService } from '~web-portal/services/policy-service';

export class ReferralMagicLinkService {
  async getLink(languageId: LanguageId): Promise<string> {
    const policies = await policyService.getPolicies();
    if (!policies?.length) return;

    const applicationId = policies.map((x) => x?.applicationId).find((id) => !isNil(id));
    if (isNil(applicationId)) return;

    const { accessToken } = getUserAuth();
    const token = await applicationClient.generateAuthorizationToken$(accessToken, applicationId).toPromise();

    return new MagicLinkHelper().generateReferralProgram(
      FrontendCommonConfig.frontendWeb.baseUrl,
      token,
      applicationId,
      languageId,
    );
  }
}

export const referralMagicLinkService = new ReferralMagicLinkService();
